"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sentenceDelimiters = new RegExp(/\.|\!|\?/);
exports.subSentenceDelimiters = new RegExp(/,|;|:/);
exports.wordDelimiter = new RegExp(/\ |\ /);
exports.paragraphDelimiter = new RegExp(/\n\n/);
//# sourceMappingURL=constants.js.map